<template>
  <div
    class="user-page-header d-flex justify-space-between align-start"
    data-testid="setup-users__header"
  >
    <div class="user-page-header__left">
      <div class="user-page-header__title-prefix" data-testid="setup-users__title-prefix">
        Setup
      </div>
      <div
        class="user-page-header__title-group d-flex align-center"
        data-testid="setup-users__title-group"
      >
        <h3 class="user-page-header__title" data-testid="setup-users__title">
          User Management
        </h3>
        <v-tooltip bottom content-class="tooltip-bottom">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              small
              class="shadow-off"
              :disabled="loading"
              :loading="loading"
              data-testid="setup-users__refresh-btn"
              @click="$emit('refresh')"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Refresh</span>
        </v-tooltip>
      </div>
      <p class="user-page-header__description" data-testid="setup-users__subtitle">
        Manage users, assign roles, and control permissions across your organization.
      </p>
    </div>
  </div>
</template>

<script>
import './UserPageHeader.scss';

export default {
  name: 'UserPageHeader',

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
